import React, {useState} from "react";
import {fetcher, URL_STATS_INTERACTIONS} from "../../../utils/fetcher";
import useSWR from 'swr';
import {toBrowserDate} from "../../../utils/utils";
import {connect} from "react-redux";

import ReactExport from "react-export-excel";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const StatisticsInteractions = props =>  {

    const { token } = props;

    const [dateFrom, setDateFrom] = useState(new Date());
    const [dateTo, setDateTo] = useState(new Date());

    const updateDateToHandler = (value) => {
        if (!dateFrom) {
            setDateFrom(value)
        }
        setDateTo(value)
    }

    const { data } = useSWR([`${URL_STATS_INTERACTIONS}${dateFrom ? '?from=' + toBrowserDate(dateFrom) : ''}${dateTo ? '&to=' + toBrowserDate(dateTo) : ''}`, token], fetcher)

    const chatsData = data?.result ? data.result.map(el => {
        return {
            ...el,
        }
    }) : [];

    return (
        <div className='mt-20'>
            <h5>Активность</h5>
            <div className="mt-15">
                <div>Дата от:</div>
                <div className="wp-100 mt-5">
                    <input type="date" className="wp-100" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
                </div>
            </div>
            <div className="mt-15">
                <div>Дата до:</div>
                <div className="wp-100 mt-5">
                    <input type="date" className="wp-100" value={dateTo} onChange={(e) => updateDateToHandler(e.target.value)} />
                </div>
            </div>

            <div className='separator mt-10' />

            <div className="mt-20">
                <p className='mt-10'>{`Всего строк: ${chatsData?.length || 0}`}</p>

                {chatsData?.length > 0 &&
                    <div className="mt-20">
                        <div className="mt-20">
                            <p>Скачать данные по активности:</p>
                            <ExcelFile>
                                <ExcelSheet data={chatsData} name="Rating">
                                    <ExcelColumn label="ID специалиста" value="doctorId"/>
                                    <ExcelColumn label="Специализация" value="specialization"/>
                                    <ExcelColumn label="Заключений" value="conclusions"/>
                                    <ExcelColumn label="Сообщений" value="messages"/>
                                </ExcelSheet>
                            </ExcelFile>
                        </div>
                    </div>
                }

            </div>

        </div>
    );
}

const mapStateToProps = ({  data: { token }}) => {
    return { token }
};


export default connect(mapStateToProps)(StatisticsInteractions);
